export const getListService = async (account_id) => {
  const res = await fetch(
    `https://catchy-api.glitch.me/api/search/${account_id}`
  );
  const data = await res.json();
  return data;
};
